import React, { useEffect, createContext, useState } from "react";
import {
  Switch,
  Route,
  BrowserRouter,
  useHistory,
  useLocation,
} from "react-router-dom";
import "./App.scss";
import { Redirect } from "react-router-dom";
import Cookies from "js-cookie";
import Home from "./pages/Home";
import { Modal, message } from "antd";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";

const ReachableContext = createContext(null);
const config = {
  title: "Token không hợp lệ!",
  maskClosable: false,
  footer: null,
  content: (
    <>
      <ReachableContext.Consumer>
        {(name) => `Có lỗi xảy ra vui lòng trở về trang chủ`}
      </ReachableContext.Consumer>
    </>
  ),
};

const App = () => {
  const [modal, contextHolder] = Modal.useModal();
  const queryParams = new URLSearchParams(window.location.search);
  let IdRequest = queryParams.get("id_request");
  const [token, setToken] = useState(
    IdRequest ? null : localStorage.getItem("hotelToken")
  );
    // http://localhost:3000/booking-hotel?id_request=3e721dfb0001bc11000601958ea05d00&cif_pk=b1c43db50001bc11000201819907a80b&device_id=FBEE5A462E423686881CB35E1864122F&request_date=1741854629256&signature=H3gSW9W03XaQWTx0O7TB2LgfM7qTr4eOboGN4NEhnqPFXTprdK/zLXj8J0ItbzjzVuWiXdZ2vDpY7/+LDTu5rTV3n+H939kmKyslGUAOKx0q99F83SuYrV12wBF9D3oo+nWL5X1IHi6BztxNGwqd/YtJfjzasrzH5mkWrybNvTtDzdATCVCqQJNKNdaDMF8K/impSudi4DdxyxfQQ9Q6bYHhkVEyur3xgcnDS/KXA5BF6zIyil+ppMmxiJuyKkgp36BTTa+DKMwAYx0ulp7oe1EbktKVj9j0h2YQuabpgVLKEcg0mfgthEuFZbJv97JJ5BmbPH4PPifV0V9aEc6sPw==

  const decodeToken = async () => {
    // Lấy token từ URL
    try {
      if (IdRequest) {
        const IdRequest = queryParams.get("id_request");
        const CifPk = queryParams.get("cif_pk");
        const DeviceId = queryParams.get("device_id");
        const RequestDate = queryParams.get("request_date");
        const Signature = queryParams.get("signature");
        localStorage.removeItem("hotelToken");
        const res = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/v1/auth/login-namabank`,
          {
              IdRequest: IdRequest,
              CifPk: CifPk,
              PartnerId: "NAB",
              DeviceId: DeviceId,
              RequestDate: RequestDate,
              Signature: Signature,
              TypeService: "hotel",
          },
        );
        const accesstoken = res.data.data.accesstoken;
        localStorage.setItem("hotelToken", accesstoken);
        setToken(accesstoken);
        const userInfo = res?.data?.data?.userinfo;
        if (userInfo) {
          userInfo.phone = userInfo?.phone?.replace(/^84/, "0");
          sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
        }
      } else {
        modal.error(config);
      }
    } catch (error) { 
      message.error(error?.response?.data?.message || "Có lỗi xảy ra");
    }
  };

  useEffect(() => {
    decodeToken();
  }, []);

  return (
    <>
      <Switch>
        {/* <Redirect exact from="/" to={accessToken ? "/dashboard/home" : "/login"} /> */}
        {/* <RouteUnauthenticated path="/login" component={Login} /> */}
        {/* <RouteAuthenticated path="/dashboard/home" component={Home} /> */}
        <Redirect exact from="/" to={"/booking-hotel"} />
        <Route
          exact
          path={"/booking-hotel"}
          render={(props) => <Home {...props} token={token} />}
        />
        <Redirect to={"/booking-hotel"} />
      </Switch>
      {contextHolder}
    </>
  );
};

// const RouteAuthenticated = ({ component: Component, path }) => {1
//  const accessToken = Cookies.get("accessToken");
//   if (!accessToken) {
//     return <Redirect to="/login" />;
//   }
//   return (
//     <LayoutClient>
//       <Route exact component={Component} path={path} />
//     </LayoutClient>
//   )
// };

const RouteUnauthenticated = ({ component: Component, path }) => {
  // const accessToken = Cookies.get("accessToken");
  // if (accessToken) {
  //   return <Redirect to="/dashboard/home" />;
  // }

  return <Route exact component={Component} path={path} />;
};

export default App;
